import PropTypes from 'prop-types';

// @mui
import { Box, Card, Link, Typography, Stack, Button } from '@mui/material';
// utils
// components
import Switch from 'src/components/Switch/Switch';
import { useState } from 'react';
import ConfirmLockModal from 'src/components/modal/ConfirmLockModal';
import { sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import ButtonAction from 'src/components/Button.js/SaveButton';
import Loader from 'src/components/loader/loader';
import ConfirmModal from 'src/components/modal/ConfirmModal';
// ----------------------------------------------------------------------

DrawerCard.propTypes = {
    product: PropTypes.object,
};

export default function DrawerCard({
    idPermission,
    navigate,
    setData,
    product,
    functEdit,
    fuctDelete,
    getData,
    screenPermissions,
}) {
    const [visibleLock, setVisibleLock] = useState(false);
    const lockRefFlags = useRef(false);
    const delFlags = useRef(false);
    const [deleleFlags, setDeleleFlags] = useState(false);
    const { t } = useTranslation();
    const [visibleDel, setVisibleDel] = useState(false);
    const [lockFlags, setLockFlags] = useState(false);
    const handleLock = () => {
        if (!product.id || !idPermission) return toast.error(t('error.system_error'));
        if (lockRefFlags.current) {
            return;
        }
        setLockFlags(true);
        lockRefFlags.current = true;
        const InVal = [+idPermission, product.cabinet_id, product.id, product.block_status === '1' ? '0' : '1'];
        sendRequest(serviceList.lockDrawer, InVal, lockResult, true, timeOutFunctLock, 40000);
    };

    const lockResult = (reqInfoMap, message) => {
        setLockFlags(false);
        lockRefFlags.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            setVisibleLock(false);
            return;
        } else {
            setVisibleLock(false);
            getData();
        }
    };

    const timeOutFunctLock = (reqInfo) => {
        setLockFlags(false);
        lockRefFlags.current = false;
        toast.error(t('error.time_out'));
    };

    const handleDelete = () => {
        if (!product.id) return toast.error(t('error.system_error'));
        if (delFlags.current) {
            return;
        }
        setDeleleFlags(true);
        delFlags.current = true;
        const InVal = [+idPermission, product.cabinet_id, product.id];
        sendRequest(serviceList.deletedrawer, InVal, deleteResult, true, timeOutFunctDel, 40000);
    };

    const deleteResult = (reqInfoMap, message) => {
        setDeleleFlags(false);
        delFlags.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            setVisibleDel(false);
            return;
        } else {
            toast.success(message['proc_message']);
            setVisibleDel(false);
            getData();
        }
    };

    const timeOutFunctDel = (reqInfo) => {
        setDeleleFlags(false);
        delFlags.current = false;
        toast.error(t('error.time_out'));
    };

    return (
        <Card style={{ cursor: 'pointer' }}>
            <ConfirmLockModal visible={visibleLock} setVisible={setVisibleLock} handleSave={handleLock} />
            <ConfirmModal
                visible={visibleDel}
                setVisible={setVisibleDel}
                loading={deleleFlags}
                handleDelete={handleDelete}
            />
            <Stack spacing={1} sx={{ p: 2 }}>
                <Link
                    color="inherit"
                    underline="hover"
                    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                    onClick={() => {
                        setData(product);
                        product.cells_x > 0 ? navigate() : functEdit();
                    }}
                >
                    <Typography variant="subtitle1" noWrap>
                        {product?.drawer_nm ? product.drawer_nm : 'Chưa cấu hình'}
                    </Typography>

                    <Button
                        href="#text-buttons"
                        sx={{
                            fontStyle: 'italic',
                            textDecoration: 'underline',
                        }}
                        variant="text"
                    >
                        {t('detail')}
                    </Button>
                </Link>

                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    onClick={() => {
                        setData(product);
                        product.cells_x > 0 ? navigate() : functEdit();
                    }}
                >
                    <Typography variant="subtitle1">
                        <Typography
                            component="span"
                            variant="body1"
                            sx={{
                                color: 'text.disabled',
                            }}
                        >
                            ID {t('drawer')}:
                        </Typography>
                        &nbsp;
                        {product?.drawer_lc}
                    </Typography>
                </Stack>
                {product.cabinet_type === 'square' ? (
                    <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        onClick={() => {
                            setData(product);
                            product.cells_x > 0 ? navigate() : functEdit();
                        }}
                    >
                        <Typography variant="subtitle1">
                            <Typography
                                component="span"
                                variant="body1"
                                sx={{
                                    fontSize: '14px',
                                    color: 'text.disabled',
                                }}
                            >
                                {t('no_row')}:
                            </Typography>
                            &nbsp;
                            {product?.cells_y}
                        </Typography>
                        <Typography variant="subtitle1">
                            <Typography
                                component="span"
                                variant="body1"
                                sx={{
                                    fontSize: '14px',
                                    color: 'text.disabled',
                                }}
                            >
                                {t('no_column')}:
                            </Typography>
                            &nbsp;
                            {product?.cells_x}
                        </Typography>
                        <Typography variant="subtitle1">
                            <Typography
                                component="span"
                                variant="body1"
                                sx={{
                                    fontSize: '14px',
                                    color: 'text.disabled',
                                }}
                            >
                                {t('total_cell')}
                            </Typography>
                            &nbsp;
                            {product?.cells_x * product.cells_y}
                        </Typography>
                    </Stack>
                ) : (
                    <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        onClick={() => {
                            setData(product);
                            product.cells_x > 0 ? navigate() : functEdit();
                        }}
                    >
                        <Typography variant="subtitle1">
                            <Typography
                                component="span"
                                variant="body1"
                                sx={{
                                    color: 'text.disabled',
                                }}
                            >
                                {t('total_cell')}
                            </Typography>
                            &nbsp;
                            {product?.cells_x * product.cells_y}
                        </Typography>
                    </Stack>
                )}
                <Stack direction="row" alignItems="center" justifyContent="center">
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            flexWrap: 'wrap',
                            '& > *': {
                                m: 1,
                            },
                        }}
                    >
                        {screenPermissions?.block_permission === '1' && (
                            <Switch
                                checked={product.block_status === '1' ? true : false}
                                onClick={() => setVisibleLock(true)}
                            />
                        )}{' '}
                        <Stack sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexDirection: 'row' }}>
                            {' '}
                            {screenPermissions?.update_permission === '1' && (
                                <ButtonAction
                                    onClick={() => {
                                        setData(product);
                                        functEdit();
                                    }}
                                    title={t('update')}
                                    type="update"
                                />
                            )}{' '}
                            {screenPermissions?.delete_permission === '1' && (
                                <ButtonAction
                                    onClick={() => {
                                        setVisibleDel(true);
                                    }}
                                    title={t('delete')}
                                    type="delete"
                                />
                            )}
                        </Stack>
                    </Box>
                </Stack>
            </Stack>
        </Card>
    );
}
